<ng-form #form="ngForm">
    <account-edit-form-layout [source]="this"
                              [sectionTitle]="'Email address' | translate"
                              [inFormTitle]="'Edit email address' | translate">
        <input-wrap class="m-t-6 block">
            <input class="input"
                   type="text"
                   name="email"
                   autocomplete="email"
                   [(ngModel)]="data.email"
                   [muiInput]="('Email Address'| translate)"
                   validatePattern="email"
                   maxlength="80"
                   required
                   email
                   #emailInput>
        </input-wrap>
    </account-edit-form-layout>
</ng-form>